import { render, staticRenderFns } from "./td-timestamp.vue?vue&type=template&id=c4ff9acc"
import script from "./td-timestamp.vue?vue&type=script&lang=js"
export * from "./td-timestamp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports